import { useEffect } from 'react';
import type L from 'leaflet';
import { useEditorModeContext } from '../../context/EditorModeContext.utils';

interface Props {
  map: L.Map;
}

export function AddPositionHandler({ map }: Props) {
  const { mode, setPlacementCoords } = useEditorModeContext();
  const active = mode.kind === 'placement-awaiting-click';

  useEffect(() => {
    if (!active) return;
    const container = map.getContainer();
    const prevCursor = container.style.cursor;
    container.style.cursor = 'crosshair';

    function onClick(e: L.LeafletMouseEvent) {
      setPlacementCoords([e.latlng.lat, e.latlng.lng]);
    }

    map.on('click', onClick);
    return () => {
      map.off('click', onClick);
      container.style.cursor = prevCursor;
    };
  }, [active, map, setPlacementCoords]);

  return null;
}
